/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_HomepageInputs */

const en_marketing_homepage = /** @type {(inputs: Marketing_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homepage`)
};

const es_marketing_homepage = /** @type {(inputs: Marketing_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página de inicio`)
};

const fr_marketing_homepage = /** @type {(inputs: Marketing_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page d'accueil`)
};

/**
* | output |
* | --- |
* | "Homepage" |
*
* @param {Marketing_HomepageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_homepage = /** @type {((inputs?: Marketing_HomepageInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_HomepageInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_homepage(inputs)
	if (locale === "es") return es_marketing_homepage(inputs)
	return fr_marketing_homepage(inputs)
});